import React, { useState, useRef } from 'react'
import { array, bool, string, node } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import useIsomorphicLayoutEffect from '@/hooks/useIsomorphicLayoutEffect'
import useWindowWidth from '@/hooks/useWindowWidth'
import CardSkeleton from '../ProductList/Card/Skeleton'
import DeveloperCard from './DeveloperCard'

const developersWrapperCss = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: 20px;

  ${mediaQueries.xlargeScreen()} {
    margin-left: -20px;
    margin-right: -20px;
  }
`

const DevelopersList = ({
  items,
  cardComponent: CardComponent = DeveloperCard,
  className,
  isFetching,
}) => {
  const [visibleProducts, setVisibleProducts] = useState(0)

  const firstCardRef = useRef(null)
  const width = useWindowWidth(100)

  const calcVisibleProductsNumber = (
    containerWidth,
    iconWidth = 32,
    margins = 72
  ) => {
    return (containerWidth - margins) / iconWidth
  }

  useIsomorphicLayoutEffect(() => {
    if (!isFetching) {
      setVisibleProducts(
        calcVisibleProductsNumber(firstCardRef?.current?.offsetWidth)
      )
    }
  }, [isFetching, width])

  if (isFetching) {
    return (
      <div css={developersWrapperCss} className={className}>
        {[...Array(3).keys()].map((index) => (
          <CardSkeleton key={index} />
        ))}
      </div>
    )
  }

  return (
    <div
      css={developersWrapperCss}
      data-test="developersWrapper"
      className={className}
    >
      {items?.map((item, index) => (
        <CardComponent
          key={item.id}
          innerRef={index === 0 ? firstCardRef : null}
          productsNumber={visibleProducts}
          dev={item}
        />
      ))}
    </div>
  )
}

DevelopersList.propTypes = {
  items: array,
  cardComponent: node,
  className: string,
  isFetching: bool,
}

export default DevelopersList
